import { defaultLocale } from '../app.constants';
import { JobColumn } from '../shared/models/job.model';
import { UserSettings } from '../shared/models/user-settings.model';

export const USER_SETTINGS_KEY = 'flywheelSettings';

export const defaultSessionSettings: Partial<UserSettings> = Object.freeze({
  showAllData: false,
});

export const defaultLocalSettings: Partial<UserSettings> = Object.freeze({
  dismissBrowserWarning: false,
  locale: defaultLocale,
  originalTimezones: false,
  runGearRulesOnMove: false,
});

export const defaultServerSettings: Partial<UserSettings> = Object.freeze({
  job_log_columns: Object.values(JobColumn),
  tasks_columns_disabled: [],
  task_manager_columns: [],
});

export function getLocalStorageSettings(): UserSettings {
  let localSettings: Partial<UserSettings>;
  try {
    localSettings = { ...defaultLocalSettings, ...JSON.parse(localStorage.getItem(USER_SETTINGS_KEY)) };
  } catch (error) {
    localSettings = defaultLocalSettings;
  }
  let sessionSettings: Partial<UserSettings>;
  try {
    sessionSettings = { ...defaultSessionSettings, ...JSON.parse(sessionStorage.getItem(USER_SETTINGS_KEY)) };
  } catch (error) {
    sessionSettings = defaultSessionSettings;
  }
  return { ...localSettings, ...sessionSettings } as UserSettings;
}

export function obscurePhoneNumber(phoneNumber): string {
  if (!phoneNumber) {
    return '';
  }
  const countryCode = phoneNumber.substring(0, 1);
  const firstNumber = phoneNumber.substring(1, 2);
  const lastTwoNumbers = phoneNumber.substring(phoneNumber.length - 2);
  const asterisks = '*'.repeat(phoneNumber.length - 4);
  return `${countryCode}${firstNumber}${asterisks}${lastTwoNumbers}`;
}
